import { Breadcrumb as AntdBreadcrumb } from 'antd';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { SingleLineEllipsis } from 'components/styles';

export const Breadcrumb = styled(AntdBreadcrumb)`
  margin-left: var(--layout-03);
`;

export const BreadcrumbButton = styled(Button).attrs({ type: 'link' })`
  padding: 0;
  height: auto;
  max-width: 20%;
  min-height: auto;

  > span {
    ${SingleLineEllipsis};
  }
`;

export const SubHeaderSection = styled.div`
  align-items: center;
  display: flex;

  > div {
    margin-right: var(--layout-04);
  }

  button {
    ${SingleLineEllipsis};
    display: flex;
    margin: 0 calc(-1 * var(--spacing-03));
    padding: 0 var(--spacing-03);
    text-align: left;
    width: 160px;
  }
`;

export * from '../styles';
